/**
 * Stable opaque id for THIS browser session, used by workspace live-sync
 * to suppress own-save echoes (I save → server broadcasts → I must not
 * re-fetch my own change).
 *
 * sessionStorage on purpose: two tabs in the same browser get DIFFERENT
 * ids, so an edit in tab A still syncs into tab B. localStorage would
 * make them share one id and break that.
 */

const KEY = "tickview_client_id";

let cached: string | null = null;

export function getClientId(): string {
  if (cached) return cached;
  try {
    const existing = sessionStorage.getItem(KEY);
    if (existing) {
      cached = existing;
      return cached;
    }
    const id =
      typeof crypto !== "undefined" && "randomUUID" in crypto
        ? crypto.randomUUID()
        : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(KEY, id);
    cached = id;
    return cached;
  } catch {
    // Storage blocked — fall back to an in-memory id (still stable for
    // the lifetime of this page).
    if (!cached) cached = `mem-${Math.random().toString(36).slice(2)}`;
    return cached;
  }
}
